const host = {
  socketServer: '',
  authServer: 'https://idp-dev.unicloudgroup.com.vn/realms/realm_ksgfinance',
  apiServer: 'https://dev.api.unicloudgroup.com.vn',
  apiCoreServer: 'https://dev.api.ksgcore.unicloudgroup.com.vn',
  apConfigServer: 'https://dev.api.ksgadm.unicloudgroup.com.vn',
  uploadServer: 'https://data.sunshinegroup.vn/api/v1/FileHandler',
  apiInvestServer: '',
  apiInvpluserver: '',
  cloudFunction: 'https://asia-northeast1-sunshine-app-production.cloudfunctions.net',
  apisreServer: '',
};
// Bám theo origin đang chạy để login được ở cả domain dev lẫn máy local / IP LAN.
// Trước đây 3 URI dưới bị hard-code về https://dev-core.ksggroup.vn nên chạy `ng serve`
// là Keycloak đá thẳng về domain đó, không quay lại được máy đang test.
// Lưu ý: origin nào cũng phải được khai báo trong Valid Redirect URIs của client
// `ksg-web-core-client` trên Keycloak, không thì IDP vẫn từ chối (lỗi Invalid redirect_uri).
const appOrigin = typeof window !== 'undefined' && window.location
  ? window.location.origin
  : 'https://dev-core.ksggroup.vn';

const authenSettings = {
  authority: host.authServer,
  client_id: 'ksg-web-core-client',
  redirect_uri: appOrigin + '/auth-callback',
  post_logout_redirect_uri: appOrigin,
  response_type: 'id_token token',
  scope: 'openid profile api_sre api_core_bigtec',
  filterProtocolClaims: true,
  loadUserInfo: true,
  automaticSilentRenew: true,
  silent_redirect_uri: appOrigin + '/silent-refresh.html'
};


const firebase = {
  apiKey: 'AIzaSyAb3orVc8nnGT0L2JgbdzXrRND393mFiFU',
  authDomain: 'sunshine-app-production.firebaseapp.com',
  databaseURL: 'https://sunshine-app-production.firebaseio.com',
  projectId: 'sunshine-app-production',
  storageBucket: 'sunshine-app-production.appspot.com'
  // apiKey: 'AIzaSyAczqJoNnTDPPLktoPtQ694IH38sR8wX6w',
  // authDomain: 'sunshine-super-app.firebaseapp.com',
  // databaseURL: 'https://sunshine-super-app.firebaseio.com',
  // projectId: 'sunshine-super-app',
  // storageBucket: 'sunshine-super-app.appspot.com',
  // messagingSenderId: '504497996884',
  // appId: '1:504497996884:web:e07732b704e759529819c1',
};

export const environment = {
  production: true,
  apiBase: host.apiServer,
  apiCoreBase: host.apiCoreServer,
  apConfigBase: host.apConfigServer,
  authBase: host.authServer + '/connect/token',
  socketServer: host.socketServer,
  url_conversation: host.socketServer + '/api/v1/conversation',
  url_member: host.socketServer + '/api/v1/member',
  uploadServer: host.uploadServer,
  cloudFunctionServer: host.cloudFunction,
  apiInvestBase: host.apiInvestServer,
  apiInvplusBase: host.apiInvpluserver,
  url_chatuserins: host.socketServer + '/api/v1/user',
  url_getgrouptype: host.socketServer + '/api/v1/grouptype',
  apiChatGetGroupType: host.socketServer + '/api/v1/grouptype',
  apisreBase: host.apisreServer,
  authenSettings: authenSettings,
  firebase
};
